export const PromoCode = [
  '100CASH',
  '200CASH',
  'ONALLY',
  'TRADE90',
  'TRADE90IRA',
  'CT60',
  'CT60SB',
  'MP6PROMO2018',
  'MP3PROMO2019',
  'MP3MONTHSMINT',
  'RAFSD',
  'RAFMP',
  'RAFSDY',
  'RAFMPY',
  'allyemployee',
  'CT61',
  'CT100',
  'CT150',
  'CT250',
  'CTV0',
  'CTV2',
  'CTV3',
  'CTV4',
  'CTV5',
  'CTV6',
  'CTV7',
  'CTV50',
  'CTV100',
  'INV100',
  'INV200',
  'IRA2026',
  'INV1530'
];
